// extracted by mini-css-extract-plugin
export default {"container":"Purifier_container__Cp0Ct","carousal":"Purifier_carousal__98Brf"};